export default function () {
  // Insert the Google Tag Manager script.
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0],
      j: any = d.createElement(s),
      dl = l != 'dataLayer'
        ? '&l=' + l
        : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', process.env.DATA_LAYER_NAME, process.env.GTM_WORKSPACE_NAME);

  // Insert another script into the top of the HTML body.
  const gtmNoscript = document.createElement('noscript');
  const gtmIframe = document.createElement('iframe');
  gtmNoscript.appendChild(gtmIframe);
  gtmIframe.setAttribute('name', 'gtmIframe');
  gtmIframe.setAttribute('src', `https://www.googletagmanager.com/ns.html?id=${process.env.GTM_WORKSPACE_NAME}&l=${process.env.DATA_LAYER_NAME}`);
  gtmIframe.setAttribute('height', '0');
  gtmIframe.setAttribute('width', '0');
  gtmIframe.setAttribute('style', 'display:none;visibility:hidden');
  const firstBodyEl = window.document.body.firstChild;
  window.document.body.insertBefore(gtmNoscript, firstBodyEl);
}